import axios from "axios";
import { getAuthHeader } from "./authService";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/api/contacts/`;
const NOTES_API_URL = `${process.env.REACT_APP_SERVER_URL}/api/contacts/notes`;

export type ContactPayload = {
  id?: number;
  company_id: number;
  first_name: string;
  last_name?: string | null;
  email?: string | null;
  phone?: string | null;
  job_title?: string | null;
  is_primary?: boolean;
  notes?: string | null;
  remind_at?: string | null;
};

export type ContactNote = {
  id: number;
  user_id: number;
  contact_id: number;
  body: string;
  createdAt: string;
  updatedAt: string;
  author?: { id: number; username: string; email: string } | null;
};

export const getContact = async (id: number) => {
  const headers = getAuthHeader();
  try {
    const response = await axios.get(`${API_URL}${id}`, { headers });
    return response.data;
  } catch (error: any) {
    console.log(error.message);
    return null;
  }
};

export const createContactNote = async (contactId: number, body: string) => {
  const headers = getAuthHeader();
  try {
    const response = await axios.post(NOTES_API_URL, { contact_id: contactId, body }, { headers });
    return response.data as ContactNote;
  } catch (error: any) {
    console.log(error.message);
    return null;
  }
};

export const updateContactNote = async (contactId: number, noteId: number, body: string) => {
  const headers = getAuthHeader();
  try {
    const response = await axios.put(`${NOTES_API_URL}/${noteId}`, { contact_id: contactId, body }, { headers });
    return response.data as ContactNote;
  } catch (error: any) {
    console.log(error.message);
    return null;
  }
};

export const deleteContactNote = async (contactId: number, noteId: number) => {
  const headers = getAuthHeader();
  try {
    await axios.delete(`${NOTES_API_URL}/${noteId}`, { headers, data: { contact_id: contactId } });
    return true;
  } catch (error: any) {
    console.log(error.message);
    return false;
  }
};

export const getContacts = async (params?: { company_id?: string; q?: string }) => {
  const headers = getAuthHeader();
  try {
    const response = await axios.get(`${API_URL}`, { headers, params });
    return response.data || [];
  } catch (error: any) {
    console.log(error.message);
    return [];
  }
};

export const createContact = async (data: ContactPayload) => {
  const headers = getAuthHeader();
  try {
    const response = await axios.post(`${API_URL}`, data, { headers });
    return response.data;
  } catch (error: any) {
    console.log(error.message);
    return null;
  }
};

export const importContactsBulk = async (contacts: ContactPayload[]) => {
  const headers = getAuthHeader();
  try {
    const response = await axios.post(`${API_URL}import`, { contacts }, { headers });
    return response.data;
  } catch (error: any) {
    console.log(error.message);
    return null;
  }
};

export const updateContact = async (id: number, data: Partial<ContactPayload>) => {
  const headers = getAuthHeader();
  try {
    const response = await axios.put(`${API_URL}${id}`, data, { headers });
    return response.data;
  } catch (error: any) {
    console.log(error.message);
    return null;
  }
};

export const deleteContact = async (id: number) => {
  const headers = getAuthHeader();
  try {
    const response = await axios.delete(`${API_URL}${id}`, { headers });
    return response.data;
  } catch (error: any) {
    console.log(error.message);
    return null;
  }
};

